/**
 * @file 文章列表（有图片）
 * @author wangzhuang
 */


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class ListPro extends Component {
    static propTypes = {
        title: PropTypes.string,
        brief: PropTypes.string,
        imgSrc: PropTypes.string,
        time: PropTypes.string,
        tagList: PropTypes.array
    };

    render() {
        const {title, brief, imgSrc, time, tagList} = this.props;
        return (
            <div className={'list-pro mui-flex pr'}>
                <div className={'list-multiple'}>
                    <div className={'list-content'}>
                        {title}
                    </div>
                    <div className={'list-brief'}>
                        {
                            time ? <span className="list-time">{time}</span> : ''
                        }
                        {brief}
                    </div>
                </div>
                <div className={'list-thumb cell'}>
                    <div className={'list-thumb-shadow'}></div>
                    <img src={imgSrc} alt={title} width={'100%'}/>
                </div>
                {
                    tagList
                        ? <div className={'tag-mod'}>
                            {
                                tagList.map((item, index) => {
                                    if (index < 2) {
                                        return <div key={index}>{item.tagname}</div>;
                                    }
                                    return '';
                                })
                            }
                        </div>
                        : null
                }

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ListPro/index.js